// import   "./NewLesson.css";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import LessonForm from "./components/LessonForm";
import { useNavigate } from "react-router-dom"; import lessonStore from "../lessonStore";
import appStore, { BreadcrumbsDI } from "../../../base/stores/AppStore";
import { addLesson } from "../services/addLesson";
import { LessonFormObjectDI } from "../types";
import _ from "lodash";
import { useState, useEffect } from "react";
import CustomModal from "../../../base/modal/Modal";
import { useTitle } from "react-use";
import SubHeader from "../../../base/sub-header/SubHeader";
import AppStore from "../../../base/stores/AppStore";

const AddLesson = () => {
  useEffect(() => {
    lessonStore.getLists();
  }, []);
  const { lists } = lessonStore;
  const { t } = useTranslation();
  useTitle(t("General-content-header") + "-" + t("Lesson-add-lesson-header"));
  const [hasError, setHasError] = useState(false);
   const navigate = useNavigate(); 

  const [errorMessage, setErrorMessage] = useState("");
  const [errorCode, setErrorCode] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [breadCrumbs, setBreadCrumbs] = useState<BreadcrumbsDI[]>();

  useEffect(() => {
   const link = document.createElement("link");
   link.rel = "stylesheet";
   link.href = "/NewLesson.css";
   document.head.appendChild(link);
  
   return () => {
  document.head.removeChild(link);
   };
  }, []);

  const handleModalStatus = (errorMode: boolean) => {
    setModalOpen(errorMode);
  };

  const handleSubmit = async (form: LessonFormObjectDI) => {
    try {
      appStore.incrementLoadingProcedure();
      await addLesson({
        ...form,
        projectPartnerIds: form.projectPartnerIds.map(id => +id),
      });
      lessonStore.getLists();
      lessonStore.setLessonJustAdded(true);
      navigate(appStore.lessonsRoute);
    } catch (error: any) {
      if (error.statusCode === 2) {
        setModalOpen(true);
        setErrorMessage(t("Lesson-main-error-validation"));
        return;
      }
      if (error.statusCode < 400) {
        setErrorMessage(error.errorMessages);
      } else {
        setErrorMessage(t("GeneralError"));
      }
      setErrorCode(error.statusCode);
      setModalOpen(true);
    } finally {
      appStore.decrementLoadingProcedure();
    }
  };

  return (
    <div className={'container'}>
    <div className="">  <SubHeader
        links={[
          { name: "Breadcrumbs-Home-Page", route: "/" },
          { name: "Lesson-search-header", route: AppStore.lessonsRoute },
          { name: "Lesson-add-lesson-header", isLast: true },
        ]}
        showBackgroundImage={false}
      />
      <div className={'header'}>{t("Lesson-add-lesson-header")}</div>
      {hasError && (
        <div
          className={'error'}
          role="alert"
          aria-label={t("Lesson-main-error-validation")}
        >
          {t("Lesson-main-error-validation")}
        </div>
      )}</div>
      <LessonForm
        onErrorStateChange={setHasError}
        availableValues={{
          allLessonField: lists.fieldId.map((i) => ({
            value: i.id,
            text: i.name,
            hide: i.hide,
          })),
          allLessonTags: lists.lessonTags.map((i) => ({
            value: i.id,
            text: i.name,
            hide: i.hide,
          })),
          allProjectName: lists.projectNameId.map((i) => ({
            value: i.id,
            text: i.name,
            hide: i.hide,
          })),
          allProjectPartners: lists.projectPartnerIds.map((i) => ({
            value: i.id,
            text: i.name,
            hide: i.hide,
          })),
          allStep: lists.stepId.map((i) => ({
            value: i.id,
            text: i.name,
            hide: i.hide,
          })),
          allProjectType: lists.projectTypeId.map((i) => ({
            value: i.id,
            text: i.name,
            hide: i.hide,
          })),
          allExternalFactorInvolved: lists.externalFactorInvolvedId.map(
            (i) => ({ value: i.id, text: i.name, hide: i.hide })
          ),
          allOrganizationalUnit: lists.organizationalUnitId.map((i) => ({
            value: i.id,
            text: i.name,
            hide: i.hide,
          })),
        }}
        onSubmit={(form) => {
          handleSubmit(form);
        }}
      />
      {modalOpen ? (
        <CustomModal
          text={errorMessage}
          isOpen={modalOpen}
          handleModalStatus={handleModalStatus}
        />
      ) : null}
    </div>
  );
};

export default observer(AddLesson);
